export default "__VITE_ASSET__BxButZr1__"